import {
  FormattedHTMLMessage,
  FormattedMessage,
  defineMessages,
  injectIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

import { emailSeat } from '../../../../ducks/seatmap';
import { getTickets } from '../../../../ducks/event';
import { navigate } from '../../../../helpers';
import Loader from '../../components/Loader';
import Option from '../components/Option';
import styles from '../seatmap.scss';
import withUser from '../../../../components/withUser';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      ticketId: PropTypes.string,
    }),
    url: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
  // error: PropTypes.oneOfType([
  //   PropTypes.string,
  //   PropTypes.bool,
  // ]),
  loading: PropTypes.bool,
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })),
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    shortcode: PropTypes.string,
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      gifted: PropTypes.string,
      forced: PropTypes.bool,
    }),
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

const messages = defineMessages({
  emailSeatTitle: {
    id: 'seatmap.done.emailSeatTitle',
    defaultMessage: '{hasMailed, select, true {Email sent} other {Email me my seat}}',
  },
  emailSeatDescription: {
    id: 'seatmap.done.emailSeatDescription',
    defaultMessage: '{hasMailed, select, true {An email was sent to {userEmail}} other {Send an email with your seat information to your inbox.}}',
  },
  giftTitle: {
    id: 'seatmap.done.giftTitle',
    defaultMessage: 'Give the ticket away',
  },
  giftDescription: {
    id: 'seatmap.done.giftDescription',
    defaultMessage: 'Give the ticket you just placed away to a friend or family member.',
  },
  manageTitle: {
    id: 'seatmap.done.manageTitle',
    defaultMessage: 'Manage more tickets',
  },
  manageDescription: {
    id: 'seatmap.done.manageDescription',
    defaultMessage: 'Go back and manage more tickets.',
  },
  appTitle: {
    id: 'seatmap.done.appTitle',
    defaultMessage: 'Get the app',
  },
  appDescription: {
    id: 'seatmap.done.appDescription',
    defaultMessage: 'Download the DreamHack app to check-in at the event.',
  },
});

class Done extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMailed: false,
    };

    const { location } = props;
    if (location && location.state && location.state.forced) {
      window.close();
    }
  }

  componentDidMount() {
    const {
      dispatch,
      user,
      event,
    } = this.props;

    if (user && user.id && event) {
      dispatch(getTickets(event.id));
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { dispatch, event: oldEvent, user: oldUser } = this.props;
    const { event, user } = newProps;
    if ((user && !oldUser) || (!oldEvent && event) || (oldEvent && oldEvent.id !== event.id)) {
      dispatch(getTickets(event.id));
    }
  }

  onEmailSeat = (ticket) => {
    const { dispatch, event } = this.props;
    dispatch(emailSeat(event.id, ticket.id))
      .then(() => {
        this.setState({
          hasMailed: true,
        });
      });
  }

  render() {
    const {
      history,
      tickets,
      user,
      event,
      match: { params },
      location,
      loading,
      intl,
    } = this.props;
    const { hasMailed } = this.state;
    const { ticketId } = params;
    const { formatMessage } = intl;
    const gifted = location && location.state && location.state.gifted;
    const doneTicket = tickets && tickets.find((ticket) => ticket.id === ticketId);

    return (
      <>
        <Loader loading={loading} />
        { event && tickets && ((doneTicket && doneTicket.expanded_seat) || gifted)
          && (
            <>
              <div className={styles.title}>
                <FormattedMessage
                  id="seatmap.done.gifted.title"
                  defaultMessage="{gifted, select, true {Your gift is on its way} other {All done}}!"
                  values={{ gifted: !!gifted }}
                />
              </div>
              { gifted
                ? (
                  <div className={styles.description}>
                    <FormattedHTMLMessage
                      id="seatmap.done.gifted.description"
                      defaultMessage="You are all done! The ticket you gave away is now on its way to <strong>{gifted}</strong>. They will receive an email with instructions on how to manage their tickets and seats."
                      values={{ gifted }}
                    />
                  </div>
                )
                : (
                  <div className={styles.description}>
                    <FormattedHTMLMessage
                      id="seatmap.done.placed.description"
                      defaultMessage="You are all done! Your ticket has been placed on <strong>{rowName}:{seatName}</strong> in <strong>{floorName}</strong>. See you at DreamHack 😎"
                      values={{
                        rowName: doneTicket.expanded_seat.expanded_row.name,
                        seatName: doneTicket.expanded_seat.name,
                        floorName:
                          doneTicket.expanded_seat.expanded_row.expanded_section.floor.name,
                      }}
                    />
                  </div>
                )}
              { user
              && (
                <>
                  { !gifted
                  && (
                    <>
                      <Option
                        icon="envelope"
                        title={formatMessage(messages.emailSeatTitle, { hasMailed })}
                        description={formatMessage(
                          messages.emailSeatDescription,
                          { hasMailed, userEmail: user.email },
                        )}
                        onClick={hasMailed ? null : () => this.onEmailSeat(doneTicket)}
                        disabled={hasMailed}
                      />
                      <Option
                        icon="gift"
                        title={formatMessage(messages.giftTitle)}
                        description={formatMessage(messages.giftDescription)}
                        onClick={() => navigate(history, `/tickets/${event.shortcode}/gift/${ticketId}`)}
                      />
                    </>
                  )}
                  <Option
                    icon="ticket-alt"
                    title={formatMessage(messages.manageTitle)}
                    description={formatMessage(messages.manageDescription)}
                    onClick={() => navigate(history, `/tickets/${event.shortcode}/manage`)}
                  />
                  <Option
                    icon="mobile"
                    title={formatMessage(messages.appTitle)}
                    description={formatMessage(messages.appDescription)}
                    onClick={() => navigate(history, '/app/download')}
                  />
                </>
              )}
            </>
          )}
      </>
    );
  }
}

Done.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    event: state.getIn(['event', 'data']),
    error: state.getIn(['event', 'error']),
    loading: state.getIn(['event', 'loading']),
    tickets: state.getIn(['event', 'tickets']),
  };
}

export default injectIntl(withRouter(withUser(connect(mapStateToProps)(Done))));
